import { DynamicQuestion, SurveySection } from "./types";

// Standard Lists used across the app (can be referenced or copied into options)
export const HOUSE_OWNERSHIP = ['സ്വന്തം', 'കോളനി', 'സ്വപാധിക ഉടമസ്ഥത', 'വാടക', 'പുറമ്പോക്'];
export const HOUSE_CONDITION = ['ഓട്', 'ഭാഗിക ടെറസ്', 'ഒറ്റനില ടെറസ്', 'ഇരുനില മാളിക', 'ബംഗ്ലാവ്'];
export const HOUSE_FACILITIES = ['വൈദ്യുതി', 'ഗ്യാസ്', 'കിണർ', 'പൊതുടാപ്പ്', 'വാട്ടർ സപ്ലൈ', 'പൊതു കിണർ'];
export const VEHICLES = ['സൈക്കിൾ', 'ടു വീലർ', 'ത്രീ വീലർ', 'കാർ', 'മറ്റുള്ളവ'];
export const ASSETS = ['ഭൂസ്വത്ത്', 'കൃഷി നിലം', 'വാടക കെട്ടിടം'];
export const AGRICULTURE = ['തെങ്ങ്', 'കവുങ്ങ്', 'റബ്ബർ', 'നെൽകൃഷി', 'പച്ചക്കറി', 'പുഷ്പം'];
export const HEALTH_CONDITIONS = [
  'സംതൃപ്തം', 'പ്രമേഹം', 'പ്രഷർ', 'ഹൃദ്രോഗം', 'ക്ഷയം', 'വാതം', 'ആസ്തമ', 'ക്യാൻസർ',
  'തിമിരം', 'കിഡ്‌നി രോഗം', 'ത്വക് രോഗം', 'ദന്ത രോഗങ്ങൾ', 'ഉദര രോഗങ്ങൾ',
  'മാനസികം', 'അംഗവൈകല്യം', 'അന്ധത / ബധിരത / മൂകത', 'മറ്റേതെങ്കിലും'
];
export const SOCIAL_WORK_OPTIONS = [
  'രാഷ്‌ടീയം', 'മത സംഘടന', 'സർവീസ് സംഘടന', 'സന്നദ്ധ പ്രവർത്തനം',
  'മഹല്ല് പ്രവർത്തനം', 'മറ്റേതെങ്കിലും', 'പ്രവാസി സംഘടന'
];

export const INITIAL_SECTIONS: SurveySection[] = [
  { id: 'sectionA', label: 'Section A: Household & Student Info', order: 0, isRepeater: false },
  { id: 'sectionC', label: 'Section C: House & Assets', order: 2, isRepeater: false },
  { id: 'sectionD', label: 'Section D: General Info', order: 3, isRepeater: false },
];

// These questions will be loaded into storage if empty
export const INITIAL_QUESTIONS: DynamicQuestion[] = [
  // --- SECTION A ---
  { id: 'serialNo', label: 'ക്രമനമ്പർ (Serial No)', type: 'text', section: 'sectionA', required: true },
  { id: 'studentName', label: 'വിദ്യാർത്ഥിയുടെ പേര് (Student Name)', type: 'text', section: 'sectionA', required: true },
  { id: 'parentName', label: 'രക്ഷിതാവിന്റെ പേര് (Parent/Guardian Name)', type: 'text', section: 'sectionA', required: true },
  { id: 'age', label: 'വയസ്സ് (Age)', type: 'number', section: 'sectionA', required: true },
  { id: 'gender', label: 'ലിംഗഭേദം (Gender)', type: 'select', section: 'sectionA', options: ['Male', 'Female', 'Other'], required: true },
  { id: 'houseName', label: 'വീട്ട് പേര്', type: 'text', section: 'sectionA', required: true },
  { id: 'wardNo', label: 'വാർഡ് നമ്പർ', type: 'text', section: 'sectionA', required: true },
  { id: 'phone', label: 'മൊബൈൽ ഫോൺ നമ്പർ', type: 'text', section: 'sectionA', required: true },
  { id: 'isIICMember', label: 'ഐ.ഐ.സി മെമ്പർഷിപ്പ് ഉണ്ടോ? (IIC Member?)', type: 'yesno', section: 'sectionA', required: true },
  { id: 'photo', label: 'വിദ്യാർത്ഥിയുടെ ഫോട്ടോ (Student Photo)', type: 'image', section: 'sectionA' },
];